import { render, staticRenderFns } from "./BusinessBranchOrCategorySelector.vue?vue&type=template&id=72cffbca&scoped=true"
import script from "./BusinessBranchOrCategorySelector.vue?vue&type=script&lang=ts"
export * from "./BusinessBranchOrCategorySelector.vue?vue&type=script&lang=ts"
import style0 from "./BusinessBranchOrCategorySelector.vue?vue&type=style&index=0&id=72cffbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cffbca",
  null
  
)

export default component.exports